import styled from 'styled-components'

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
  z-index: 1;
  height: 40px;
`
